import React from 'react';
import './Home.css';
import logo from '../../../assets/images/logo.svg';
import MarqueeBackground from '../../MarqueeBackground/MarqueeBackground';
import { useIsMobile } from '../../../hooks/useIsMobile';

const Home = ({ onCtaClick }) => {
  const isMobile = useIsMobile();

  return (
    <section id="home" className="home-section">
      <img src={logo} alt="Logo" className="home-logo" />
      <div className="home-content">
        <h2>MORE THAN A STREAMING SERVICE</h2>
        <h1>HOME OF<br/>
        <span className="creative-highlight">
          {!isMobile &&
          <MarqueeBackground />
          }
          CREATIVE
        </span><br/>
        MISFITS</h1>
        {isMobile &&
        <MarqueeBackground />
        }
        <p>This isn't another lifeless scroll-fest; it's a thriving creative rebellion.<br/>
        If you crave something different, live to discover, and love hyping<br/> originality before the world slaps a trend label on it – welcome home.</p>
        <button onClick={onCtaClick}>DON'T MISS OUT ON WHAT'S TO COME</button>
      </div>
    </section>
  );
};

export default Home; 